import * as React from 'react';
import { observer } from 'mobx-react';
import './page-template.scss';
import { useTranslation } from 'react-i18next';
import useStore from '../../../store';
import { useMemo } from 'react';

interface ILink {
  url: string;
  key: string;
}

interface IProps {
  titleElement: React.JSX.Element;
  contentElement: React.JSX.Element;
}

export const PageTemplate = observer((props: IProps) => {
  const { t } = useTranslation('', { keyPrefix: 'PAGE_TEMPLATE' });
  const { titleElement, contentElement } = props;
  const { tenantStore } = useStore();
  const { config } = tenantStore;
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const additionalLinks = useMemo(() => {
    const links: ILink[] = [];
    if (config.privacyPolicyUrl) links.push({ url: config.privacyPolicyUrl, key: t('PRIVACY_POLICY') });
    return links;
  }, [config.privacyPolicyUrl]);
  return (
    <div className="container-template">
      <div className="template-body">
        <div className="title d-flex">{titleElement}</div>

        <div className="container-grey">{contentElement}</div>

        <ul className="links d-flex">
          <li id="li_net2phone_url">
            <a href={config.net2PhoneUrl} target="_blank">
              {t('NET2PHONE')}
            </a>
          </li>
          {additionalLinks.map(link => (
            <li key={link.key}>
              <span>&#8226;</span>
              <a href={link.url} target="_blank">
                {link.key}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div className="template-inner">
        <div className="container">
          <p className="text-right">
            <small>
              <span> </span>
              {t('COPYRIGHT', { currentYear })}
            </small>
          </p>
        </div>
      </div>
    </div>
  );
});
